import assert from 'assert';
import { DeleteDataExportForm } from 'components/dataExport/DeleteDataExportForm';
import React, { type FC } from 'react';
import dedent from 'ts-dedent';
import { useWorkspace } from 'wrappers/WorkspaceProvider';

import { CodeBlock } from '@fragment/ui/src/components/CodeBlock/CodeBlock';
import { TextInputCopy } from '@fragment/ui/src/components/TextInputCopy/TextInputCopy';

import type { DataExportRow } from './DataExportsList';

type DataExportDetailProps = {
  dataExport: DataExportRow;
  onConfirmedDelete: () => void;
};
export const DataExportDetail: FC<DataExportDetailProps> = ({
  dataExport,
  onConfirmedDelete,
}) => {
  const { workspace } = useWorkspace();
  assert(workspace);

  let url = `s3.console.aws.amazon.com/s3/buckets/${dataExport.exportBucketName}?region=${dataExport.exportBucketRegion}`;
  if (dataExport.exportBucketKey) {
    url += `&prefix=${dataExport.exportBucketKey}/`;
  }
  return (
    <div className="space-y-f2">
      <span>{dataExport.id}</span>
      <div>
        <TextInputCopy
          width="w-full"
          size="md"
          padding="p-f0"
          id="export-url"
          label="Export URL"
          value={url}
        />
      </div>
      <div className="space-y-f1">
        <div className="w-full max-w-full overflow-hidden">
          <CodeBlock
            language="json"
            title="S3 Bucket Policy"
            textSize="md"
            codeClassName="max-w-full"
          >
            {dedent`{
              "Version": "2012-10-17",
              "Statement": [
                {
                  "Sid": "PutObjects",
                  "Effect": "Allow",
                  "Principal": {
                    "AWS": "arn:aws:iam::${workspace.pod.awsAccountId}:root"
                  },
                  "Action": "s3:PutObject",
                  "Resource": "arn:aws:s3:::${dataExport.exportBucketName}/*"
                }
              ]
            }`}
          </CodeBlock>
        </div>
      </div>
      <DeleteDataExportForm
        dataExport={dataExport}
        onDelete={onConfirmedDelete}
      />
    </div>
  );
};
